// In a new file, e.g., useViewportVisibility.js (or replace useLazyVisible.js content)

import { useState, useEffect, useRef } from 'react'

export const useViewportVisibility = (options) => {
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // 1. Get the element (the div surrounding CeramicItem)
    const element = ref.current
    if (!element) return

    // 2. Create the observer
    const observer = new IntersectionObserver(([entry]) => {
      // 3. CRITICAL: Update state based on current intersection status (in or out)
      setIsVisible(entry.isIntersecting)

      // DO NOT DISCONNECT
    }, options)

    // 4. Start observing
    observer.observe(element)

    // 5. Cleanup: Disconnect when the component unmounts
    return () => observer.unobserve(element)
  }, [options]) // Rerun effect if options change

  // Return the ref and the live visibility status
  return [ref, isVisible]
}
